<template>
    <v-list-item>
        <v-list-item-avatar :color="iconColour" size="40">
            <span :class="fontColour + `--text`">{{ iconValue }}</span>
        </v-list-item-avatar>
        <v-list-item-content>
            <v-list-item-title>
                <user-display-name :user="comment.createdBy"></user-display-name>
            </v-list-item-title>
            <div :class="`rounded-lg grey pa-3 ${$vuetify.theme.dark ? 'darken' : 'lighten'}-3`">
                {{ latestVersion.comment }}
            </div>
            <v-list-item-subtitle>
                <created-date :created-date="comment.createdDate" />
                <span v-if="hasEdit"> Edited at <created-date :created-date="latestVersion.createdDate" /> </span>
                <span class="ml-2">
                    <v-btn v-if="canEdit" x-small color="secondary" outlined @click="beginEdit">
                        Edit
                    </v-btn>
                    <v-btn v-if="canDelete" x-small color="error" outlined class="ml-2" @click="beginDelete">
                        Delete
                    </v-btn>
                </span>
            </v-list-item-subtitle>
        </v-list-item-content>
    </v-list-item>
</template>
<script>
import { mapState } from 'vuex'
export default {
    props: {
        comment: {
            type: Object,
            required: true,
        },
        isLastChild: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        ...mapState(['user']),
        getFormattedDate() {
            return this.$options.filters.luxonToolTipDateTime(this.comment.createdDate)
        },
        canEdit() {
            return this.comment.createdBy.id === this.user.id
        },
        canDelete() {
            return this.user.isAdmin || (this.canEdit && this.isLastChild)
        },
        latestVersion() {
            if (!this.comment.edits || this.comment.edits.length === 0) return this.comment
            let edits = this.comment.edits
            return edits.sort((a, b) => (a.createdDate > b.createdDate ? -1 : b.createdDate > a.createdDate ? 1 : 0))[0]
        },
        hasEdit() {
            return this.comment.edits && this.comment.edits.length > 0
        },
        iconColour() {
            return this.comment?.createdBy?.iconColour ?? '#000000'
        },
        iconValue() {
            let initials = 'AB'
            if (this.commentUser.firstName.length > 0) {
                initials = `${this.commentUser.firstName[0]}${initials[1]}`
            }
            if (this.commentUser.lastName.length > 0) {
                initials = `${initials[0]}${this.commentUser.lastName[0]}`
            }
            return initials
        },
        commentUser() {
            return this.comment.createdBy
        },
        fontColour() {
            let hexcolor = this.iconColour.replace('#', '')
            const [r, g, b] = [0, 2, 4].map(p => parseInt(hexcolor.substr(p, 2), 16))
            return (r * 299 + g * 587 + b * 114) / 1000 >= 128 ? 'black' : 'white'
        },
    },
    methods: {
        beginEdit() {
            this.$emit('beginEdit', this.comment.id, this.latestVersion.comment, this.comment.parentId)
        },
        beginDelete() {
            this.$emit('beginDelete', this.comment.id)
        },
    },
}
</script>
